import { z } from 'zod';
import { OffsetPaginationParamsSchema } from '../offset-pagination.js';
export const USER_ROLES = {
    TENANT_ADMIN: 'tenant_admin',
    USER: 'user',
};
export const UserRoleSchema = z.enum(Object.values(USER_ROLES));
export const USER_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
};
export const UserStatusSchema = z.enum(Object.values(USER_STATUSES));
/**
 * Password complexity rule (REQ-CORE-015):
 * min 8 chars, at least 1 uppercase, 1 lowercase, 1 digit.
 */
export const PasswordSchema = z
    .string()
    .min(8, 'Hasło musi mieć minimum 8 znaków')
    .max(128, 'Hasło nie może przekraczać 128 znaków')
    .regex(/[A-Z]/, 'Hasło musi zawierać co najmniej jedną wielką literę')
    .regex(/[a-z]/, 'Hasło musi zawierać co najmniej jedną małą literę')
    .regex(/[0-9]/, 'Hasło musi zawierać co najmniej jedną cyfrę');
export const UserDtoSchema = z.object({
    id: z.number().int().positive(),
    tenantId: z.number().int().positive(),
    email: z.email('Niepoprawny format adresu e-mail').max(320),
    displayName: z.string().min(1).max(255),
    role: UserRoleSchema,
    status: UserStatusSchema,
    hasFinanceAccess: z.boolean(),
    twoFactorEnabled: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const CreateUserRequestSchema = z.object({
    email: z.email('Niepoprawny format adresu e-mail').max(320),
    displayName: z.string().min(2, 'Imię i nazwisko musi mieć minimum 2 znaki').max(255),
    role: UserRoleSchema.default(USER_ROLES.USER),
    hasFinanceAccess: z.boolean().default(false),
    password: PasswordSchema.optional(),
});
export const UpdateUserRequestSchema = z.object({
    displayName: z.string().min(2, 'Imię i nazwisko musi mieć minimum 2 znaki').max(255).optional(),
    role: UserRoleSchema.optional(),
    status: UserStatusSchema.optional(),
    hasFinanceAccess: z.boolean().optional(),
});
export const UserListQuerySchema = OffsetPaginationParamsSchema.extend({
    status: UserStatusSchema.optional(),
    role: UserRoleSchema.optional(),
    search: z.string().max(100).optional(),
});
//# sourceMappingURL=users.schema.js.map